module.exports = __webpack_public_path__ + "static/img/register.2c4ae191.jpg";